import React from 'react';
import { observer } from 'mobx-react';
import { JobStore, SiteStore } from '@seedlang/stores';
import { computed } from 'mobx';
import autobind from 'autobind-decorator';
import InPlaceText from 'components/form/in_place_text';
import InPlaceSelect from 'components/form/in_place_select';
import Grid from 'components/layout/grid';

@observer
class JobEdit extends React.Component {
  componentDidMount() {
    this.getJob();
    SiteStore.getIndex();
  }

  componentDidUpdate(prevProps) {
    if (this.props.routeParams.pageId !== prevProps.routeParams.pageId) {
      this.getJob();
    }
  }

  componentWillUnmount() {
    JobStore.clearShowData();
  }

  @computed get job() {
    return JobStore.showData;
  }

  @autobind getJob() {
    JobStore.getShow({ ids: { jobId: this.props.routeParams.jobId }}, this.afterGetShow);
  }

  @autobind afterGetShow(resp) {
    JobStore.setShowData(resp);
  }

  render() {
    return (
      <div className='job-edit'>
        {
          JobStore.hasShowData &&
          <Grid columns={3} gap='sm'>
            <InPlaceText
              legend='Name'
              id={this.job.id}
              defaultValue={this.job.title}
              model='jobs'
              field='title'
            />
            <InPlaceSelect
              legend='Site'
              includeBlank={false}
              options={SiteStore.indexData.map(item => [item.id, item.name])}
              value={this.job.siteId}
              model='jobs'
              field='site_id'
              id={this.job.id}
              afterChange={JobStore.reloadShow.bind(JobStore)}
            />
            <InPlaceText
              legend='Content'
              wrapperClassName='word-info'
              markdown
              defaultValue={this.job.bodyMd}
              model='jobs'
              field='body_md'
              inputType='textarea'
              id={this.job.id}
            />
          </Grid>
        }
      </div>
    );
  }
}

export default JobEdit;
